import { useHostServices } from '@/composables/format-edit/useHostServices'

export function useEprintFunnel() {
  const { gtm } = useHostServices()

  function send(name: string, params: Record<string, unknown> = {}) {
    gtm.sendEprintEvent(name, params)
  }

  return {
    send,
    sendPurchase: (params: Record<string, unknown>) =>
      gtm.sendEprintPurchase(params),
    sendError: (area: string, msg: string) => gtm.sendError(area, msg),
    generateFunnelSessionId: () => gtm.generateFunnelSessionId(),
    getPrintTypeLabel: (printType: string) => gtm.getPrintTypeLabel(printType),
    getPrintTypePrice: (printType: string) => gtm.getPrintTypePrice(printType),
    getStoreLabel: (storeKey: string) => gtm.getStoreLabel(storeKey)
  }
}
